/**
 * This file was generated by TypeScriptGen v0.0.3
 * Any changes to this file will be lost if regenerated 
 */

enum LabInputUnit {
    MgKgPpm = "MgKgPpm",
    Meq100g = "Meq100g"
}

export default LabInputUnit;
